import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68003fb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-successfully-created-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check-circle-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "check-circle" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-check fs-56" })
  ])
], -1))
const _hoisted_3 = { class: "success-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-print fs-24" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-print fs-24" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-back fs-10" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("cashier.label.order-has-been", [_ctx.orderNumber])), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("cashier.label.successfully-processed")), 1)
    ]),
    (_ctx.jobId > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printReceiptClick && _ctx.printReceiptClick(...args))),
          type: "button",
          class: "print"
        }, [
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.print-receipt")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.printTicketAction && _ctx.printTicketAction(...args))),
      type: "button",
      class: "print"
    }, [
      _hoisted_5,
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.print-tickets")), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "to-products",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
    }, [
      _hoisted_6,
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.back-home")), 1)
    ])
  ]))
}